import { Link } from "react-router-dom";
import { HelpCircle, ArrowLeft } from "lucide-react";

export default function FAQ() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Frequently Asked Questions</h1>
                </div>

                <div className="space-y-6 text-gray-700">
                    <div>
                        <h3 className="font-semibold text-indigo-700 flex items-center gap-2">
                            <HelpCircle className="w-5 h-5" /> How do I reset my password?
                        </h3>
                        <p className="text-sm mt-1">
                            Go to the login page and click �Forgot Password.� A 6-digit code will be sent to your registered email.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-indigo-700 flex items-center gap-2">
                            <HelpCircle className="w-5 h-5" /> Can I take exams offline?
                        </h3>
                        <p className="text-sm mt-1">
                            Yes. ExamsPro supports offline delivery with secure synchronization once the device reconnects.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-indigo-700 flex items-center gap-2">
                            <HelpCircle className="w-5 h-5" /> How is my data protected?
                        </h3>
                        <p className="text-sm mt-1">
                            ExamsPro encrypts all data in transit (TLS 1.3) and at rest (AES-256) under SecureID�s SOC 2 framework.
                        </p>
                    </div>
                </div>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link to="/support/contact" className="bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition">
                        Ask a Question
                    </Link>
                    <Link to="/solutions/examspro" className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition">
                        <ArrowLeft className="w-4 h-4" /> Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
